import { render, staticRenderFns } from "./PartiallyAcceptedTabs.vue?vue&type=template&id=42bdea0c&scoped=true&"
import script from "./PartiallyAcceptedTabs.vue?vue&type=script&lang=js&"
export * from "./PartiallyAcceptedTabs.vue?vue&type=script&lang=js&"
import style0 from "./PartiallyAcceptedTabs.vue?vue&type=style&index=0&id=42bdea0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdea0c",
  null
  
)

export default component.exports